import { useMemo } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import { useUrlSyncedFilters } from '@/hooks/useUrlSyncedFilters';
import { useUrlSyncedSearch } from '@/hooks/useUrlSyncedSearch';
import { toDonationBatchFilterSearch, toDonationBatchFilterValues } from '../utils/mpFilters';

const ROUTES = {
  publish: getRouteApi('/_auth/market-promotion/publish-panel/'),
  accounts: getRouteApi('/_auth/market-promotion/accounts-adjust'),
} as const;

export type DonationBatchPanel = keyof typeof ROUTES;

const normalizeFilterValues = (values: Record<string, string>) =>
  toDonationBatchFilterValues(toDonationBatchFilterSearch(values));

export function useDonationBatchFilters(panel: DonationBatchPanel) {
  const route = ROUTES[panel];
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const appliedValues = useMemo(() => toDonationBatchFilterValues(search), [search]);

  const filters = useUrlSyncedFilters({
    appliedValues,
    shouldWaitForApply: true,
    normalizeValues: normalizeFilterValues,
    onApply: (values) => {
      void navigate({
        search: (previous) => ({ ...previous, ...toDonationBatchFilterSearch(values) }),
        replace: true,
      });
    },
  });

  const searchBox = useUrlSyncedSearch({
    appliedText: search.search,
    onApply: (text) => {
      void navigate({
        search: (previous) => ({ ...previous, search: text }),
        replace: true,
      });
    },
  });

  return { ...filters, ...searchBox, search };
}
